<template>
  <a-drawer :title="title" width="60%" :visible="visible" :body-style="{ paddingBottom: '80px' }" @close="onClose">
    <a-spin :spinning="loading">
      <div class="drawer-content">
        <!-- 基本信息 -->
        <a-descriptions title="基本信息" :column="2" bordered>
          <a-descriptions-item label="订单号">{{ detailData.orderNo || '-' }}</a-descriptions-item>
          <a-descriptions-item label="订单状态">
            <a-tag :color="getStatusColor(detailData.status)">{{ getStatusText(detailData.status) }}</a-tag>
          </a-descriptions-item>
          <a-descriptions-item label="订单来源">{{
            orderSourceMap[detailData.orderSource] || '-'
          }}</a-descriptions-item>
          <a-descriptions-item label="订单类型">{{ orderTypeMap[detailData.orderType] || '-' }}</a-descriptions-item>
          <a-descriptions-item label="订单标签">{{ detailData.label || '-' }}</a-descriptions-item>
          <a-descriptions-item label="是否评价">
            <a-tag :color="detailData.isEvaluate ? 'green' : 'red'">
              {{ detailData.isEvaluate ? '已评价' : '未评价' }}
            </a-tag>
          </a-descriptions-item>
          <a-descriptions-item label="是否支付">
            <a-tag :color="detailData.isPayed ? 'green' : 'red'">
              {{ detailData.isPayed ? '已支付' : '未支付' }}
            </a-tag>
          </a-descriptions-item>
          <a-descriptions-item label="上门类型">
            {{ upDoorTypeMap[detailData.isUpDoor] || '-' }}
          </a-descriptions-item>
          <a-descriptions-item label="退款状态">{{
            refundStatusMap[detailData.refundStatus] || '-'
          }}</a-descriptions-item>
          <a-descriptions-item label="退款次数">{{ detailData.refundTimes || 0 }}</a-descriptions-item>
          <a-descriptions-item label="退款金额">{{ detailData.refundAmount || 0 }}</a-descriptions-item>
          <a-descriptions-item label="用户确认状态">{{
            userConfirmMap[detailData.userConfirm] || '-'
          }}</a-descriptions-item>
        </a-descriptions>

        <!-- 费用信息 -->
        <a-descriptions title="费用信息" :column="2" bordered style="margin-top: 16px">
          <a-descriptions-item label="总值">{{ detailData.total || 0 }}</a-descriptions-item>
          <a-descriptions-item label="实际总值">{{ detailData.actualTotal || 0 }}</a-descriptions-item>
          <a-descriptions-item label="优惠总额">{{ detailData.reduceAmount || 0 }}</a-descriptions-item>
          <a-descriptions-item label="平台优惠金额">{{ detailData.platformAmount || 0 }}</a-descriptions-item>
        </a-descriptions>

        <!-- 客户信息 -->
        <a-descriptions title="客户信息" :column="2" bordered style="margin-top: 16px">
          <a-descriptions-item label="客户姓名">{{ detailData.receiverName || '-' }}</a-descriptions-item>
          <a-descriptions-item label="客户电话">{{ detailData.receiverMobile || '-' }}</a-descriptions-item>
          <a-descriptions-item label="所在地区">
            {{
              [detailData.receiverAreap, detailData.receiverAreac, detailData.receiverAreax]
                .filter(Boolean)
                .join('/') || '-'
            }}
          </a-descriptions-item>
          <a-descriptions-item label="详细地址">{{ detailData.receiverDetailedAddress || '-' }}</a-descriptions-item>
          <a-descriptions-item label="楼栋门牌号">{{ detailData.receiverBuildingNo || '-' }}</a-descriptions-item>
        </a-descriptions>

        <!-- 时间信息 -->
        <a-descriptions title="时间信息" :column="2" bordered style="margin-top: 16px">
          <a-descriptions-item label="创建时间">{{ detailData.createTime || '-' }}</a-descriptions-item>
          <a-descriptions-item label="预约时间">{{ detailData.receiverUpTime || '-' }}</a-descriptions-item>
          <a-descriptions-item label="最晚预约时间">{{ detailData.receiverUpEndTime || '-' }}</a-descriptions-item>
          <a-descriptions-item label="接单时间">{{ detailData.connectTime || '-' }}</a-descriptions-item>
          <a-descriptions-item label="派单时间">{{ detailData.groupTime || '-' }}</a-descriptions-item>
          <a-descriptions-item label="上门时间">{{ detailData.upDoorTime || '-' }}</a-descriptions-item>
          <a-descriptions-item label="付款时间">{{ detailData.payTime || '-' }}</a-descriptions-item>
          <a-descriptions-item label="完成时间">{{ detailData.finallyTime || '-' }}</a-descriptions-item>
          <a-descriptions-item label="取消时间">{{ detailData.cancelTime || '-' }}</a-descriptions-item>
          <a-descriptions-item label="用户确认时间">{{ detailData.userConfirmTime || '-' }}</a-descriptions-item>
          <a-descriptions-item label="通知时间">{{ detailData.notifyTime || '-' }}</a-descriptions-item>
        </a-descriptions>

        <!-- 维修服务项 -->
        <a-card title="维修服务项" style="margin-top: 16px" v-if="detailData.itemVo && detailData.itemVo.length">
          <a-list item-layout="horizontal" :data-source="detailData.itemVo">
            <a-list-item slot="renderItem" slot-scope="item">
              <a-list-item-meta
                :description="`数量: ${item.num} | 是否合并: ${item.mergeOrder ? '是' : '否'} | 合并订单ID: ${
                  item.mergeOrderId || '-'
                }`"
              >
                <div slot="title">{{ item.name }}</div>
              </a-list-item-meta>
              <div>{{ item.remark || '无备注' }}</div>
            </a-list-item>
          </a-list>
        </a-card>

        <!-- 维修工作收费内容 -->
        <a-card
          title="维修工作收费内容"
          style="margin-top: 16px"
          v-if="detailData.itemCostVo && detailData.itemCostVo.length"
        >
          <a-list item-layout="horizontal" :data-source="detailData.itemCostVo">
            <a-list-item slot="renderItem" slot-scope="item">
              <a-list-item-meta
                :description="`类型: ${item.type === 0 ? '服务' : '耗材'} | 数量: ${item.num} | 单价: ${
                  item.price
                } | 优惠金额: ${item.platformAmount}`"
              >
                <div slot="title">{{ item.name }}</div>
              </a-list-item-meta>
              <div>{{ item.remark || '无备注' }}</div>
            </a-list-item>
          </a-list>
        </a-card>

        <!-- 核销配件信息 -->
        <a-card
          title="核销配件信息"
          style="margin-top: 16px"
          v-if="detailData.itemMaterialVo && detailData.itemMaterialVo.length"
        >
          <a-list item-layout="horizontal" :data-source="detailData.itemMaterialVo">
            <a-list-item slot="renderItem" slot-scope="item">
              <a-list-item-meta
                :description="`类型: ${getMaterialTypeText(item.type)} | 数量: ${item.num} | 电话: ${
                  item.phone || '-'
                } | 保修时长: ${item.warrantyDuration || 0}天`"
              >
                <div slot="title">{{ item.name }}</div>
              </a-list-item-meta>
              <div>
                <div>{{ item.remark || '无备注' }}</div>
                <div v-if="item.warrantyEndTime">保修结束: {{ item.warrantyEndTime }}</div>
              </div>
            </a-list-item>
          </a-list>
        </a-card>

        <!-- 评价信息 -->
        <a-card title="评价信息" style="margin-top: 16px" v-if="detailData.evaluateVo">
          <a-descriptions :column="1" bordered>
            <a-descriptions-item label="评价星级">
              <a-rate :value="detailData.evaluateVo.level" disabled />
            </a-descriptions-item>
            <a-descriptions-item label="评价内容">{{
              detailData.evaluateVo.descriptionVal || '-'
            }}</a-descriptions-item>
            <a-descriptions-item label="是否匿名">
              {{ detailData.evaluateVo.isAnonymous ? '是' : '否' }}
            </a-descriptions-item>
            <a-descriptions-item
              label="评价图片"
              v-if="detailData.evaluateVo.fileImg && detailData.evaluateVo.fileImg.length"
            >
              <div style="display: flex; gap: 8px; flex-wrap: wrap">
                <a-image
                  v-for="(img, index) in detailData.evaluateVo.fileImg"
                  :key="index"
                  :width="80"
                  :height="80"
                  :src="img"
                  :preview-mask="false"
                />
              </div>
            </a-descriptions-item>
          </a-descriptions>
        </a-card>

        <!-- 维修师傅信息 -->
        <a-card title="维修师傅信息" style="margin-top: 16px" v-if="detailData.masterVo">
          <a-descriptions :column="1" bordered>
            <a-descriptions-item
              label="维修前后对比图"
              v-if="detailData.masterVo.afterBefore && detailData.masterVo.afterBefore.length"
            >
              <div v-for="(item, index) in detailData.masterVo.afterBefore" :key="index" style="margin-bottom: 16px">
                <div style="margin-bottom: 8px; font-weight: bold">{{ getImageTypeText(item.type) }}</div>
                <div style="display: flex; gap: 8px; flex-wrap: wrap">
                  <a-image
                    v-for="(img, imgIndex) in item.imageList"
                    :key="imgIndex"
                    :width="80"
                    :height="80"
                    :src="img"
                    :preview-mask="false"
                  />
                </div>
              </div>
            </a-descriptions-item>
          </a-descriptions>
        </a-card>

        <!-- 其他信息 -->
        <a-descriptions title="其他信息" :column="1" bordered style="margin-top: 16px">
          <a-descriptions-item label="买家备注">{{ detailData.remarks || '-' }}</a-descriptions-item>
          <a-descriptions-item label="备注">{{ detailData.remark || '-' }}</a-descriptions-item>
          <a-descriptions-item label="支付渠道通知数据">{{ detailData.channelNotifyData || '-' }}</a-descriptions-item>
          <a-descriptions-item label="订单关闭原因">{{
            closeTypeMap[detailData.closeType] || '-'
          }}</a-descriptions-item>
        </a-descriptions>
      </div>
    </a-spin>

    <div class="drawer-footer">
      <a-button @click="onClose">关闭</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { getObj } from '@/api/repairModule/repairOrder.js'

export default {
  name: 'OrderDetailDrawer',
  data() {
    return {
      visible: false,
      loading: false,
      title: '订单详情',
      detailData: {},
      orderSourceMap: { 0: '微信小程序', 1: 'APP', 2: '师傅下单' },
      orderTypeMap: { 0: '普通订单', 1: '合并订单(主)', 2: '合并订单(副)' },
      upDoorTypeMap: { 0: '未上门', 1: '异常上门', 2: '正常上门' },
      refundStatusMap: { 0: '未退款', 10: '部分退款', 20: '全部退款' },
      userConfirmMap: { 0: '默认', 1: '等待确认', 2: '已确认' },
      deleteStatusMap: { 0: '没有删除', 1: '回收站', 2: '永久删除' },
      closeTypeMap: { 1: '超时未支付', 2: '用户取消', 3: '商家取消' },
      statusMap: {
        1: '已下单',
        10: '待接单',
        11: '派单中',
        12: '转单中',
        20: '等待上门',
        21: '挂起工单',
        22: '已上门',
        23: '报价中',
        24: '维修中',
        30: '待付款',
        40: '已完成',
        50: '已取消',
        51: '已合并',
      },
      statusColorMap: {
        1: 'blue',
        10: 'orange',
        11: 'purple',
        12: 'cyan',
        20: 'gold',
        21: 'volcano',
        22: 'lime',
        23: 'green',
        24: 'green',
        30: 'red',
        40: 'green',
        50: 'gray',
        51: 'yellow',
      },
    }
  },
  methods: {
    show(record) {
      this.visible = true
      this.title = `订单详情 - ${record.orderNo}`
      this.loadDetail(record.id)
    },
    hide() {
      this.visible = false
      this.detailData = {}
    },
    onClose() {
      this.hide()
    },
    async loadDetail(id) {
      this.loading = true
      try {
        const response = await getObj(id)
        this.detailData = response.data || {}
      } catch (error) {
        console.error('加载订单详情失败:', error)
        this.$message.error('加载订单详情失败')
      } finally {
        this.loading = false
      }
    },
    getStatusText(status) {
      return this.statusMap[status] || '-'
    },
    getStatusColor(status) {
      return this.statusColorMap[status] || 'default'
    },
    getMaterialTypeText(type) {
      const typeMap = { 0: '外部（配件）', 1: '内部（配件）', 2: '其它费用' }
      return typeMap[type] || '-'
    },
    getImageTypeText(type) {
      const typeMap = { Q11: '维修前', H50: '维修后' }
      return typeMap[type] || type
    },
  },
}
</script>

<style scoped>
.drawer-content {
  padding: 0;
}

.drawer-footer {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: 1;
}

.ant-descriptions {
  margin-bottom: 0;
}

.ant-card {
  margin-bottom: 16px;
}

.ant-card:last-child {
  margin-bottom: 0;
}
</style>
